import { Alert, Grid, Typography } from "@mui/material";

export default function Info( { values }: any) {
    return (
    <Grid item md={12} sm={12} xs={12}>
        <Typography variant="h6">PRODUTOS</Typography>
        <Alert variant="filled" severity="info" icon="💡">
            <h4>
                Informe abaixo a quantidade{' '}
                {values.plan === '1' ? 'diária' : 'mensal'} para cada
                produto.
            </h4>
            <ol style={{ textAlign: 'left' }}>
                <li>
                    <strong>FREE:</strong> O sistema irá considerar o valor
                    informado como créditos, que serão descontados na medida
                    em que as consultas são realizadas, e renovado todos os
                    dias. Quando os créditos do dia acabarem a empresa não
                    conseguirá mais realizar consultas.
                </li>
                <li>
                    <strong>PRÉ PAGO:</strong> O sistema irá considerar o
                    valor informado como <strong>créditos</strong>, que
                    serão descontados na medida em que as consultas são
                    realizadas, sem prazo para expirar, quando os créditos
                    acabarem, a empresa não conseguirá mais realizar
                    consultas.
                </li>
                <li>
                    <strong>PÓS PAGO:</strong> O valor informado servirá
                    apenas como identificação do plano onde o cliente poderá
                    acompanhar seu consumo na tela inicial. Após atingir o
                    valor informado, a empresa ainda poderá realizar
                    consultas, porém ciente que entrará como consulta
                    avulsa. Uma cobrança mensal deve ser feita de acordo com
                    o contrato firmado com o cliente, não se esqueça de
                    emitir um <strong>boleto</strong> para pagamento todo
                    mês.
                </li>
            </ol>
        </Alert>
    </Grid>
    )
}